import React from 'react';
import { cn } from '../../utils/cn';

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  helperText?: string;
  mono?: boolean;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    {
      label,
      error,
      helperText,
      mono = false,
      className = '',
      id,
      disabled,
      rows = 3,
      ...props
    },
    ref
  ) => {
    const generatedId = React.useId();
    const inputId = id || generatedId;

    return (
      <div className="w-full">
        {label && (
          <label
            htmlFor={inputId}
            className="block text-xs font-medium text-cf-textSecondary mb-1"
          >
            {label}
          </label>
        )}
        <textarea
          id={inputId}
          ref={ref}
          rows={rows}
          disabled={disabled}
          className={cn(
            'w-full p-2.5 rounded-md bg-cf-input border border-cf-border text-xs text-cf-textPrimary placeholder:text-cf-textMuted focus:outline-none focus:border-cf-orange transition-colors disabled:opacity-50 disabled:cursor-not-allowed',
            mono ? 'font-mono' : 'font-sans',
            error && 'border-rose-500 focus:border-rose-500',
            className
          )}
          {...props}
        />
        {error ? (
          <span className="block text-[11px] text-rose-600 dark:text-rose-400 mt-1">
            {error}
          </span>
        ) : helperText ? (
          <span className="block text-[11px] text-cf-textMuted mt-1">
            {helperText}
          </span>
        ) : null}
      </div>
    );
  }
);

Textarea.displayName = 'Textarea';
